import { createBaseApi, getAuthHeaders } from '../utils/baseApi';

const apiVersion = 'v1';

const { getJson, postJson, deleteJson, putJson } = createBaseApi(`/api/${apiVersion}`, { headers: getAuthHeaders });

export const sendEmailAutomationStepReport = (stepId, email, userTimeZone) => postJson(`/email-automation-steps/${stepId}/reports`, { email, time_zone: userTimeZone });
